import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { DeepLinkService } from './deep-link.service';

/** 🔗 button: copies the current deep link (what is on screen) to the clipboard. */
@Component({
  selector: 'app-link-button',
  template: `
    <button type="button" class="btn btn-sm" [ngClass]="btnClass || 'btn-outline-secondary'"
            [title]="(copied ? 'LINK_COPIED' : 'LINK_COPY') | translate"
            [attr.aria-label]="'LINK_COPY' | translate"
            (click)="copy($event)">{{ copied ? '✓' : '🔗' }}</button>
  `,
})
export class LinkButtonComponent {
  /** Colour / size classes of the button (default 'btn-outline-secondary'). */
  @Input() btnClass = '';
  copied = false;
  private timer: any;

  constructor(private readonly link: DeepLinkService, private readonly cdr: ChangeDetectorRef) {}

  copy(event: Event): void {
    event.stopPropagation();
    const url = this.link.href();
    // set after the click's change detection: mark, so an OnPush host shows the ✓ too
    const done = () => {
      this.copied = true;
      this.cdr.markForCheck();
      clearTimeout(this.timer);
      this.timer = setTimeout(() => { this.copied = false; this.cdr.markForCheck(); }, 1500);
    };
    if (navigator.clipboard?.writeText) {
      navigator.clipboard.writeText(url).then(done).catch(() => window.prompt('Link', url));
    } else {
      window.prompt('Link', url);
    }
  }
}
